import React from 'react';

function PrivacyEnglish() {
  return (
    <div>
      <h1>ΠΟΛΙΤΙΚΗ για τα Cookies</h1>
      Vivian Lab URL: https://vivianlab.com
      <br />
      <br />
      Δήλωση: Αποκτώντας και διατηρώντας πρόσβαση στον ιστότοπο αυτό αποδέχεστε ρητά και την
      ακόλουθη Πολιτική χρήσης cookies. Τελευταία Αναθεώρηση του παρόντος : 16th/Νοέμβριος/2023
      <br />
      <br />
      ΓΕΝΙΚΑ
      <br />
      Η «Εταιρεία» τηρεί αυστηρή πολιτική για την προστασία της ιδιωτικότητας των επισκεπτών της
      «Ιστοσελίδας». Με το παρόν σημείωμα σας παρέχουμε περισσότερες πληροφορίες για το πώς
      χρησιμοποιούμε ηλεκτρονικά μπισκότα - COOKIES, κάθε φορά που επισκέπτεσθε την ιστοσελίδα μας.
      Θεωρούμε σημαντικό ο χρήστης να έχει ενημέρωση σχετικά με τα ποια είναι τα cookies που
      χρησιμοποιούμε στην ιστοσελίδα μας αλλά και για ποιους λόγους τα χρησιμοποιούμε. Στόχος μας
      είναι η σωστή ενημέρωση αλλά και η καλύτερη και ασφαλέστερη πλοήγηση στον ιστότοπο της
      Εταιρείας μας.
      <br />
      Τι είναι τα Cookie
      <br />
      <br />
      Tα cookies είναι σύντομα κείμενα κώδικα λογισμικού, που αποστέλλονται προς αποθήκευση από τον
      διαδικτυακό εξυπηρετητή (“server”) της Επιχείρησής μας στον τερματικό σας εξοπλισμό με βασική
      τους λειτουργία την επικοινωνία σε εμάς δεδομένων του φυλλομετρητή σας (“browser”). Ανάλογα με
      την διάρκειά τους τα cookies είναι είτε «προσωρινά» (session cookies) ή «έμμονα» (persistent
      cookies).Τα «προσωρινά cookies» είναι cookies που απαλείφονται αυτομάτως όταν κλείνετε τον
      φυλλομετρητή σας, ενώ τα «έμμονα cookies» παραμένουν αποθηκευμένα στον τερματικό σας εξοπλισμό
      μέχρι τη συμπλήρωση του προκαθορισμένου χρόνου ισχύος τους. Η αποδοχή και η χρήση των cookies
      σε καμία περίπτωση δεν προκαλούν βλάβες στον τερματικό εξοπλισμό που χρησιμοποιείτε, όπως για
      παράδειγμα PC, Smartphone, tablet, ούτε στα αρχεία που φυλάσσετε σε αυτόν.
      <br />
      <br />
      ΛΟΓΟΙ ΧΡΗΣΗΣ cookies
      <br />
      Χρησιμοποιεί η ιστοσελίδα μας Cookies;
      <br />
      Κάνουμε χρήση ορισμένων Cookies με κύριο σκοπό να καταστήσουμε την ιστοσελίδα μας  πιο
      λειτουργική και προσφιλέστερη προς τους χρήστες μας, βελτιώνοντας τη γενική λειτουργία της, τη
      σωστή και ταχεία περιήγηση, την εύκολη σύνδεση και την ομαλή μετακίνηση στις επιμέρους σελίδες
      μας. Επιπροσθέτως, χρησιμοποιούνται cookies για τη διευκόλυνση πρόσβασης του επισκέπτη /
      χρήστη στις υπηρεσίες της «Ιστοσελίδας» αλλά και για στατιστικούς λόγους προκειμένου να
      καθορίζονται οι περιοχές στις οποίες οι υπηρεσίες της «Ιστοσελίδας» είναι χρήσιμες ή
      δημοφιλείς. Όλες οι πληροφορίες που συλλέγονται από αυτά τα cookies χρησιμοποιούνται για να
      βελτιώσουν την αγοραστική εμπειρία, τη δομή, το περιεχόμενο και την αμεσότητα της ιστοσελίδας
      μας. Επίσης, με τη χρήση των cookies επιτυγχάνουμε τη συνεχή βελτιστοποίηση της λειτουργίας
      του ιστότοπου και της παροχής υπηρεσιών της Εταιρείας μας καθώς και την άμεση αντιμετώπιση
      τυχόν προβλημάτων που πιθανόν προκύπτουν.
      <br />
      <br />
      ΕΙΔΗ Cookies που χρησιμοποιούμε.
      <br />
       Η «Ιστοσελίδα» χρησιμοποιεί την τεχνολογία των cookies και ειδικά: Τα «προσωρινά
      cookies»(session cookies) για τους παρακάτω σκοπούς:
      <br />
      - Για την αυτόματη αναγνώρισή σας ως εγγεγραμμένου χρήστη μετά την σύνδεσή σας (log in) ή για
      την περιήγηση σε ασφαλείς υποσελίδες.
      <br />
      - Για την αυτόματη αναγνώρισή σας κατά την εκτέλεση συναλλαγών καθώς και χρήσης των υπηρεσιών
      μας και τα οποία είναι απαραίτητα για την λειτουργία της συνήθους εφαρμογής επιλογής
      υπηρεσιών.
      <br />
      - Για την κατανομή της επεξεργασίας αιτήσεων διακομιστή μεταξύ μιας ομάδας διακομιστών.
      <br />
      - Για την ηλεκτρονική αναγνώριση χρηστών ήδη συνδεδεμένων σε μέσα κοινωνικής δικτύωσης
      <br />
      Περαιτέρω, χρησιμοποιούμε «έμμονα cookies» για τους εξής σκοπούς:
      <br />
      - Για την βελτίωση των επιδόσεων της ιστοσελίδας μας.
      <br />
      - Για την εξατομίκευση της διεπαφής σας και την προσωποποίηση της λειτουργίας της ιστοσελίδας
      μας.
      <br />
      <br />
      <br />
      ΚΑΤΗΓΟΡΙΕΣ Cookies που χρησιμοποιούμε.
      <br />
      1) Αναγκαία Cookies
      <br />
      <br />
      Επιτρέπουν την εκτέλεση βασικών λειτουργιών του site, όπως την προσθήκη υπηρεσιών, την
      ηλεκτρονική πληρωμή και την αποθήκευση επιλογών και προτιμήσεών σας στη service - list. Χωρίς
      αυτά τα απολύτως απαραίτητα Cookies, πλήττεται άμεσα η ομαλή λειτουργία του ιστότοπου μας αλλά
      υποβαθμίζεται και η προσωπική εμπειρία πλοήγησης μιας και βασικές για την ηλεκτρονική χρήση
      των επιλογών και λειτουργιών υπολειτουργούν.
      <br />
      2) Cookies επιδόσεων
      <br />
      Τα cookies επιδόσεων συλλέγουν πληροφορίες σχετικά με το πως οι επισκέπτες χρησιμοποιούν την
      ιστοσελίδα μας. Μας επιτρέπουν να δούμε ποιες σελίδες επισκέπτονται πιο συχνά ή μας δείχνουν
      εάν αντιμετωπίζουν κάποιο πρόβλημα κατά την πλοήγηση. Αυτά τα cookies δεν συλλέγουν
      πληροφορίες που προσδιορίζουν τον επισκέπτη. Όλες οι πληροφορίες που συλλέγουν αυτά τα cookies
      είναι συγκεντρωτικές και χρησιμοποιούνται μόνο για να τη βελτίωση του τρόπου λειτουργίας του
      ιστότοπου μας.
      <br />
      3) Cookies λειτουργικότητας
      <br />
      Αυτά τα cookies «απομνημονεύουν» τις προτιμήσεις του χρήστη κατά την περιήγηση σου στον
      ιστότοπο / site μας, ώστε να μπορούμε κατόπιν εμείς αναλογικά να προτείνουμε τις κατάλληλες
      υπηρεσίες και επιλογές με βάση τις ανάγκες του χρήστη. Με αυτά τα cookies δημιουργείται μια
      εξατομικευμένη εκδοχή του ιστότοπου με αποτέλεσμα να βρίσκει ο χρήστης πολύ πιο εύκολα αυτό
      που αναζητά.
      <br />
      4) Cookies διαφήμισης
      <br />
      Αυτά τα cookies χρησιμοποιούνται για να παρέχουν διαφημίσεις πιο σχετικές με τον εκάστοτε
      χρήστη και τα ενδιαφέροντά του. Χρησιμοποιούνται επίσης για την αποστολή στοχευμένης
      διαφήμισης ή προσφορών με στόχο τον περιορισμό των μαζικών, ανεπιθύμητων και ανούσιων
      διαφημιστικών μηνυμάτων για τον χρήστη. Παράλληλα, βοηθούν στη μέτρηση της αποτελεσματικότητας
      των διαφημιστικών καμπανιών.
      <br />
      5) Cookies Analytics
      <br />
      Είναι υποσύνολο των Cookies λειτουργικότητας και παρέχουν τη δυνατότητα να αξιολογούμε την
      αποτελεσματικότητα των διάφορων λειτουργιών του ιστότοπου / site μας, έτσι ώστε να βελτιώνουμε
      συνεχώς την εμπειρία που προσφέρουμε στον χρήστη.
      <br />
      Συγκεκριμένα:
      <br />
      <br />
      Τρίτοι προμηθευτές, συμπεριλαμβανομένης της Google, δύναται να εμφανίσουν διαφημίσεις της
      Εταιρίας σε ιστότοπους στο διαδίκτυο.
      <br />
      Τρίτοι προμηθευτές, συμπεριλαμβανομένης της Google, δύναται να κάνουν χρήση cookies για την
      ενημέρωσή, βελτιστοποίηση και προβολή διαφημίσεων που βασίζονται σε προηγούμενη επίσκεψη του
      χρήστη στο δικτυακό τόπο του site μας. Ο ιστότοπος μας δύναται επίσης να αξιοποιήσει τα
      cookies από προηγούμενη επίσκεψη στην ιστοσελίδα της για επαναληπτικό μάρκετινγκ.
      <br />
      Ο χρήστης μπορεί να επιλέξει την εξαίρεσή του από τέτοια χρήση των cookies μέσω των επιλογών
      και των πρωτόκολλων διαδικασίας που προτείνει ο εκάστοτε φυλλομετρητής / Βrowser.
      <br />
      Ο χρήστης μπορεί να ρυθμίσει τον φυλλομετρητή / Browser ώστε να ενημερώνεται κάθε φορά πριν
      γίνει η λήψη ενός cookie και επομένως να αποφασίζει τη λήψη του ή την απόρριψή του. Σ' αυτή
      την περίπτωση, σας ενημερώνουμε ότι ενδέχεται να μην είστε σε θέση να αξιοποιήσετε όλες τις
      δυνατότητες του.
      <br />
      Ο ιστότοπος δύναται να χρησιμοποιεί τις λειτουργίες του Google Analytics για τις διαφημίσεις
      προβολής (π.χ., επαναληπτικό μάρκετινγκ, αναφορές εμφάνισης Δικτύου εμφάνισης Google,
      ενσωμάτωση του Διαχειριστή καμπάνιας Doubleclick και αναφορές δημογραφικών στοιχείων και
      ενδιαφερόντων)..
      <br />
      Χρησιμοποιώντας τις Ρυθμίσεις διαφημίσεων, οι χρήστες μπορούν να εξαιρεθούν από το Google
      Analytics για διαφημίσεις προβολής και να προσαρμόσουν τις διαφημίσεις του Δικτύου εμφάνισης
      Google.
      <br />
      Εδώ βρίσκονται οι διαθέσιμες επιλογές εξαίρεσης του Google Analytics για τον ιστό.
      <br />
      Ο ιστότοπος συμμορφώνεται με την Πολιτική διαφημίσεων βάσει ενδιαφέροντος του Google
      AdWords και τους περιορισμούς για ευαίσθητες κατηγορίες και: Χρησιμοποιεί επαναληπτικό
      μάρκετινγκ με το Google Analytics για διαφήμιση στο διαδίκτυο.
      <br />
      Ο ιστότοπος και οι τρίτοι πάροχοι υπηρεσιών, συμπεριλαμβανομένης της Google, χρησιμοποιούν
      μαζί cookie αρχικού κατασκευαστή (όπως το cookie του Google Analytics) και cookie τρίτου
      μέρους (όπως το cookie DoubleClick), για την ενημέρωση, τη βελτιστοποίηση και την προβολή
      διαφημίσεων, σύμφωνα με τις προηγούμενες επισκέψεις κάποιων χρηστών στον ιστότοπό της.
      <br />
      Ο ιστότοπος και οι τρίτοι πάροχοι υπηρεσιών, συμπεριλαμβανομένης της Google, χρησιμοποιούν
      μαζί cookie αρχικού κατασκευαστή (όπως το cookie του Google Analytics) και cookie τρίτου
      μέρους (όπως το cookie DoubleClick), για την εκτέλεση αναφορών σχετικά με τον τρόπο με τον
      οποίο οι εμφανίσεις των διαφημίσεών του ιστότοπου, άλλες χρήσεις υπηρεσιών διαφήμισης και οι
      αλληλεπιδράσεις με αυτές τις εμφανίσεις διαφημίσεων και υπηρεσίες διαφήμισης σχετίζονται με
      επισκέψεις στον ιστότοπο.
      <br />
      Ο ιστότοπος δύναται να χρησιμοποιεί τα δεδομένα από τη διαφήμιση βάσει ενδιαφέροντος της
      Google ή τα δεδομένα κοινού τρίτου μέρους (όπως η ηλικία, το φύλο και τα ενδιαφέροντα) με το
      Google Analytics.
      <br />
      Η Εταιρεία διατηρεί το δικαίωμα να αλλάξει αυτή την πολιτική για cookies οποτεδήποτε. Παρακαλώ
      εντόπισε το σημείο «ΤΕΛΕΥΤΑΙΑ ΑΝΑΘΕΩΡΗΣΗ» στην κορυφή της παρούσας σελίδας, για να δεις πότε
      αναθεωρήθηκε για τελευταία φορά η παρούσα Πολιτική Cookies. Οποιεσδήποτε αλλαγές στην παρούσα
      Πολιτική Cookies θα ισχύσουν από τη στιγμή που η αναθεωρημένη Πολιτική Cookies καταστεί
      διαθέσιμη στον Ιστότοπο.
      <br />
      Διαφημιστές τρίτων μερών και άλλες επιχειρήσεις που συνεργαζόμαστε μπορεί να χρησιμοποιούν τα
      δικά τους Cookies για να συλλέξουν πληροφορίες που αφορούν στις δραστηριότητες του χρήστη στον
      Ιστότοπο μας. Γίνεται μνεία ότι η εταιρείας μας δεν ελέγχει αυτά τα Cookies. ΑΠΕΝΕΡΓΟΠΟΙΗΣΗ
      Cookies ειδικότερα.
      <br />
      Μπορείτε να ενεργοποιήσετε, να απενεργοποιήσετε ή και να σβήσετε εντελώς τα cookies μέσα από
      τις επιλογές ρύθμισης στο πρόγραμμα περιήγησης που χρησιμοποιείτε. Αν επιλέξετε να
      απενεργοποιήσετε τα cookies, ορισμένα μέρη της ιστοσελίδας μπορεί να μη λειτουργούν επαρκώς
      και γι' αυτό οι χρήστες αποδέχονται εξ αρχής αυτή την επέμβαση.  Μπορείτε να επισκεφθείτε το
      διαδικτυακό τόπο χωρίς να έχετε επιτρέψει την επέμβαση των cookies, αλλά δεν θα μπορέσετε να
      χρησιμοποιήσετε όλες τις δυνατότητες της ιστοσελίδας ή να απολαύσετε συγκεκριμένα
      χαρακτηριστικά της. Για να αλλάξετε τις ρυθμίσεις των cookies σας, ανατρέξτε στο μενού
      "Βοήθεια" του προγράμματος περιήγησης (browser)
      <br />
      <br />
      ΕΙΔΙΚΟΤΕΡΑ περί δεδομένων για εκτελεσθείσες συναλλαγές.
      <br />
      Πως Δίνεται η Συγκατάθεση για την Αποδοχή της Παραπάνω Χρήσης Cookies από τον χρήστη; Με την
      είσοδο του χρήστη στην κεντρική σελίδα της «Ιστοσελίδας» λαμβάνει γνώση σχετικού σημειώματος
      για τη χρήση από μέρους μας cookies, το οποίο βρίσκεται σε περίοπτη θέση και παραπέμπει στην
      παρούσα πολιτική χρήσης με σχετική σαφή και εκτενή ενημέρωση. Σε περίπτωση, που ο χρήστης
      αποφασίσει να περιηγηθεί σε υποσελίδες της «Ιστοσελίδας» και εφόσον έχει ρυθμίσει καταλλήλως
      τον διαδικτυακό φυλλομετρητή, παρέχει ελευθέρως την ρητή και ειδική συγκατάθεση για την χρήση
      αυτή. Σε αντίθετη περίπτωση ο χρήστης υποχρεούται να απέχει από την περιήγηση εντός της
      «Ιστοσελίδας» ή να απενεργοποιήσει τη χρήση cookies στις ρυθμίσεις του φυλλομετρητή. Πως
      μπορεί ο χρήστης να απενεργοποιήσει τη χρήση Cookies;
      <br />
      <br />
      Σε περίπτωση που ο χρήστης επιθυμεί να ενεργοποιήσει ή να απενεργοποιήσει τη χρήση cookies από
      τις ρυθμίσεις του φυλλομετρητή, αναλόγως του φυλλομετρητή προτείνουμε να επισκεφθείτε τις
      ακόλουθες ιστοσελίδες, για να λάβετε γνώση για τις απαραίτητες σχετικές ενέργειες
      <br />● <a href="http://support.microsoft.com/kb/278835">Internet Explorer</a> <br />●{' '}
      <a href="http://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored">
        Firefox
      </a>{' '}
      <br />● <a href="http://support.google.com/accounts/answer/61416?hl=en">Chrome</a> <br />●{' '}
      <a href="http://www.opera.com/browser/tutorials/security/privacy/">Opera</a> <br />●{' '}
      <a href="http://support.apple.com/kb/PH5042">
        Safari <br />
      </a>
      ● <a href="http://support.apple.com/kb/HT1677">Safari</a> <br /> <br />
      Τέλος, η Εταιρεία μας παραμένει πάντοτε στη διάθεσή σας για οποιαδήποτε πληροφορία ή/και
      περαιτέρω διευκρίνηση και ερώτηση επιθυμείτε να επικοινωνήσετε μαζί μας.
    </div>
  );
}

export default PrivacyEnglish;
